import { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
// components
import ContentSearch from "@/components/ContentSearch";
import MNPG from "./MNPG";
// type
import { TMainPageLayoutV3 } from "../type";
import TOutletContext from "@/cms/types/TOutletContext";


const MNPG015 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG015.rendered: ", props);

    const { _showLoader, contentId } = useOutletContext<TOutletContext>();

    useEffect(() => { return () => { _showLoader(); }},[]);
    
    if ( !props.template ) return null;

    let unqKey = "", filter = [];
    if ( contentId ) {
        unqKey = contentId.split("-")[4];
        filter.push(`contentId eq ${contentId}`)
    }
    else if (props.params?.["contentId"]) {
        unqKey = props.params["contentId"].split("-")[4];
    }
    else {
        unqKey = props.template.id.split("-")[4];
    }

    return (
        <ContentSearch filters={filter} unqKey={unqKey}>
            <MNPG 
                templates={props.templates} 
                mapLayoutName={props.template.mapLayoutName} 
                parentId={props.template.id}
                params={props.params}
            />
        </ContentSearch>
    )
}

export default MNPG015;
